import styled from "@emotion/styled"
import { colors } from "../config/theme"

const RadioContainer = styled.div`
  min-width: 24px;
  min-height: 24px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #787878;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
`

const RadioFilled = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${colors.black};
`

export const Radio: React.FC<{ selected: boolean }> = ({ selected }) => (
  <RadioContainer>{selected && <RadioFilled />}</RadioContainer>
)
